<script lang="ts">
  import type { Snippet } from 'svelte';

  let { label, class: className = '', children }: { label: string; class?: string; children: Snippet } = $props();
</script>

<div class="phone {className}" role="img" aria-label={label}>
  <div class="device" aria-hidden="true">
    <div class="device-frame">
      <div class="device-screen">{@render children()}</div>
    </div>
    <div class="device-stripe"></div>
    <div class="device-header"></div>
    <div class="device-sensors"></div>
    <div class="device-btns"></div>
    <div class="device-power"></div>
  </div>
</div>

<style>
  /* Frame geometry adapted from devices.css iPhone 14 Pro, MIT licence, (c) 2017 Yan Zhu. */
  .phone {
    container-type: inline-size;
    width: 100%;
    margin-inline: auto;
  }
  .device {
    --u: calc(100cqi / 428);
    --frame-ring: #24365c;
    --frame-ring-dark: #16233f;
    --frame-panel: #050a16;
    position: relative;
    width: calc(428 * var(--u));
    height: calc(868 * var(--u));
    filter: drop-shadow(0 calc(30 * var(--u)) calc(40 * var(--u)) #0a1a4566);
  }
  .device *,
  .device *::before,
  .device *::after {
    box-sizing: border-box;
  }
  .device-frame {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    padding: calc(19 * var(--u));
    border: calc(1 * var(--u)) solid var(--frame-ring-dark);
    border-radius: calc(68 * var(--u));
    background: var(--frame-panel);
    box-shadow:
      inset 0 0 calc(4 * var(--u)) calc(2 * var(--u)) #8ea3d1,
      inset 0 0 0 calc(6 * var(--u)) var(--frame-ring);
  }
  .device-screen {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: calc(49 * var(--u));
    background: #f6f8fd;
    isolation: isolate;
    container-type: inline-size;
  }
  .device-stripe::before,
  .device-stripe::after {
    content: '';
    position: absolute;
    left: 0;
    z-index: 9;
    width: 100%;
    height: calc(7 * var(--u));
    border: solid #0101013f;
    border-width: 0 calc(7 * var(--u));
  }
  .device-stripe::after {
    top: calc(85 * var(--u));
  }
  .device-stripe::before {
    bottom: calc(85 * var(--u));
  }
  .device-header {
    position: absolute;
    z-index: 10;
    top: calc(29 * var(--u));
    left: 50%;
    width: calc(120 * var(--u));
    height: calc(35 * var(--u));
    margin-left: calc(-60 * var(--u));
    border-radius: calc(20 * var(--u));
    background: var(--frame-panel);
  }
  .device-sensors::before,
  .device-sensors::after {
    content: '';
    position: absolute;
    z-index: 11;
  }
  .device-sensors::after {
    top: calc(30 * var(--u));
    left: 50%;
    width: calc(74 * var(--u));
    height: calc(33 * var(--u));
    margin-left: calc(-60 * var(--u));
    border-radius: calc(17 * var(--u));
    background: var(--frame-panel);
  }
  .device-sensors::before {
    top: calc(42 * var(--u));
    left: 50%;
    width: calc(9 * var(--u));
    height: calc(9 * var(--u));
    margin-left: calc(36 * var(--u));
    border-radius: 50%;
    background:
      radial-gradient(farthest-corner at 20% 20%, #6074bf 0, transparent 40%),
      radial-gradient(farthest-corner at 80% 80%, #513785 0, #24555e 20%, transparent 50%);
  }
  .device-btns,
  .device-btns::before,
  .device-btns::after,
  .device-power {
    position: absolute;
    width: calc(3 * var(--u));
    border-radius: calc(2 * var(--u));
    background: var(--frame-ring-dark);
  }
  .device-btns {
    top: calc(115 * var(--u));
    left: calc(-2 * var(--u));
    height: calc(32 * var(--u));
  }
  .device-btns::before,
  .device-btns::after {
    content: '';
    left: 0;
    height: calc(62 * var(--u));
  }
  .device-btns::after {
    top: calc(60 * var(--u));
  }
  .device-btns::before {
    top: calc(140 * var(--u));
  }
  .device-power {
    top: calc(200 * var(--u));
    right: calc(-2 * var(--u));
    height: calc(100 * var(--u));
  }
</style>
